import { ServiceError } from './ServiceError'

export {
  BILL_NUMBER_ALREADY_EXISTS,
  CUSTOMER_VAT_NUMBER_ALREADY_EXISTS,
  DRIVER_NIF_ALREADY_EXISTS,
  EXPENSE_NUMBER_ALREADY_EXISTS,
  PAYLOAD_NAME_ALREADY_EXISTS,
  PLACE_NAME_ALREADY_EXISTS,
  PASSENGER_TRANSPORT_DOCUMENT_NUMBER_ALREADY_EXISTS,
  TRANSPORT_DOCUMENT_NUMBER_ALREADY_EXISTS,
  VEHICLE_NAME_ALREADY_EXISTS,
  VEHICLE_PLATE_ALREADY_EXISTS
} from './duplicateResourceError'

function normalizeMessages(data: Record<string, unknown> | undefined): string[] {
  if (!data) {
    return []
  }

  if (Array.isArray(data.messages)) {
    return data.messages as string[]
  }

  if (typeof data.message === 'string') {
    return [data.message]
  }

  return []
}

async function handleError(error: any): Promise<ServiceError> {
  const data = error.response?.data

  return new ServiceError(
    normalizeMessages(data),
    data?.code,
    error.response?.status,
    data?.timestamp
  )
}

export default handleError
